import { z } from 'zod';

export type PosProcessingItemProperties = z.infer<typeof PosProcessingItemProperties>;
export type PosProcessingItem = z.infer<typeof PosProcessingItem>;

export const PosProcessingItemProperties = z.object({
    message: z.string().nullish(),
    code: z.string().nullish(),
    codeType: z.string().nullish(),
    itemNames: z.array(z.string()).nullish(),
    skipShow: z.boolean().nullish(),
    localizationKey: z.string().nullish(),
    allowAppPayment: z.boolean().nullish(),
    isDiscounted: z.boolean().nullish(),
    itemName: z.string().nullish(),
    rootItemId: z.string().nullish(),
    nItems: z.number().nullish(),
    price: z.number().nullish(),
    commodityGroupId: z.string().nullish(),
    errorIndex: z.number().nullish(),
    errorTotal: z.number().nullish(),
});

export const PosProcessingItem = z.object({
    posProcessingItemGuid: z.string(),
    referenceBasketItemGuids: z.array(z.string()),
    properties: PosProcessingItemProperties,
    createdOn: z.coerce.date(),
});
